import React, { PureComponent } from "react";
import { Link } from "../../../../routes";
import { withTranslation } from "../../../../i18n";

import classes from "./styles.module.scss";
import {routes} from "../../../config/routes";

class BreadCrumbs extends PureComponent {
  render() {
    const { list, t } = this.props;
    return (
      <div className={classes.breadCrumbs}>
        <div className={classes.breadCrumb}>
          <Link route={routes.home}>
            <a>{t("main")}</a>
          </Link>
        </div>
        {list.map((item, index) => (
          <div key={index} className={classes.breadCrumb}>
            <span className={classes.breadCrumbsDelimiter}>/</span>
            {item.link && (
              <Link route={item.link}>
                <a>{item.title}</a>
              </Link>
            )}
            {!item.link && <span>{item.title}</span>}
          </div>
        ))}
      </div>
    );
  }
}

export default withTranslation(["common"])(BreadCrumbs);
